module.exports = __webpack_public_path__ + "img/text-center.54f6c21c.svg";